module.exports = __webpack_public_path__ + "img/confounder.59bd5281.png";